<section class="connect-page">
    <div class="connect-grid">
        <mat-card class="connect-card">
            <mat-card-header>
                <div class="card-title-row">
                    <div>
                        <p class="connect-section-title">Domains</p>
                        <p class="connect-subtitle">Manage the web search allowlist for this client.</p>
                    </div>
                    <div class="card-actions">
                        <button mat-stroked-button color="primary" (click)="toggleCreate()">
                            {{ showCreate ? 'Hide form' : 'Add domain' }}
                        </button>
                        <button mat-button color="primary" (click)="loadDomains()" [disabled]="loading">
                            {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                    </div>
                </div>
            </mat-card-header>

            <mat-card-content class="domains-body">
                @if (error) {
                    <div class="error-banner">{{ error }}</div>
                }

                @if (showCreate) {
                    <form class="domain-form" [formGroup]="createForm" (ngSubmit)="createDomain()">
                        <div class="form-grid">
                            <mat-form-field appearance="outline">
                                <mat-label>Domain</mat-label>
                                <input matInput formControlName="domain" placeholder="frydenbo-bil.no" />
                                <mat-hint>Use the naked domain. Subdomains are allowed automatically.</mat-hint>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Status</mat-label>
                                <mat-select formControlName="status">
                                    <mat-option value="verified">Verified</mat-option>
                                    <mat-option value="inactive">Inactive</mat-option>
                                    <mat-option value="pending">Pending</mat-option>
                                    <mat-option value="failed">Failed</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-actions">
                            <span class="connect-muted small">Used by the web_search tool allowlist.</span>
                            <span class="spacer"></span>
                            <button mat-flat-button color="primary" type="submit" [disabled]="createBusy">
                                {{ createBusy ? 'Adding...' : 'Add domain' }}
                            </button>
                        </div>
                    </form>
                }

                <div class="table-wrapper">
                    @if (loading) {
                        <div class="loading-row">
                            <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
                            <span class="connect-muted">Loading domains...</span>
                        </div>
                    } @else if (domains.length === 0) {
                        <p class="connect-muted">No domains yet. Add one to allow web search.</p>
                    } @else {
                        <div class="table-head">
                            <span>Domain</span>
                            <span>Status</span>
                            <span>Updated</span>
                            <span class="actions-col">Actions</span>
                        </div>
                        @for (domain of domains; track domain.id) {
                            <div class="table-row">
                                <span class="mono">{{ domain.domain }}</span>
                                <span [ngClass]="statusBadge(domain.status).className">
                                    {{ statusBadge(domain.status).label }}
                                </span>
                                <span class="connect-muted">{{ domain.updated_at | date:'medium' }}</span>
                                <div class="row-actions">
                                    <button mat-stroked-button color="primary" (click)="toggleStatus(domain)" [disabled]="isSaving(domain.id)">
                                        {{ domain.status === 'verified' ? 'Deactivate' : 'Activate' }}
                                    </button>
                                    <button mat-button color="warn" (click)="deleteDomain(domain)" [disabled]="isSaving(domain.id)">
                                        Delete
                                    </button>
                                </div>
                            </div>
                        }
                    }
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</section>
